"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiTabsOverrides = {
    MuiTab: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&.MuiButtonBase-root': {
                    padding: '24px 16px',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: theme.palette.gray[800],
                },
                '&.Mui-selected': {
                    color: theme.palette.blue[500],
                },
            }),
        },
    },
};
exports.default = MuiTabsOverrides;
//# sourceMappingURL=TabsOverrides.js.map